import React from "react";
import { Box, Typography } from "@mui/material";
import { useSpring, animated, config as springConfig } from "react-spring";
import { getTotalSiteVisits } from "../../api/services";
import { useQuery } from "react-query";

const SiteVisits: React.FC = () => {
  const { data, isLoading, error } = useQuery(
    "totalSiteVisits",
    getTotalSiteVisits,
    {
      refetchInterval: 3000,
    }
  );

  const totalVisits = data?.data?.visits ?? 0;

  // Animation for counter
  const { number } = useSpring({
    from: { number: 0 },
    number: totalVisits,
    delay: 300,
    config: springConfig.molasses,
  });

  if (isLoading) return null;
  if (error) return <Typography>Error fetching visits</Typography>;

  return (
    <Box
      sx={{
        position: "fixed",
        top: { xs: "50%", md: "50%" },
        left: { xs: "-90px", sm: "calc(0% - 93px)", md: "calc(0% - 110px)" },
        transform: "rotate(-90deg)",
        display: "flex",
        alignItems: "center",
        backgroundColor: "primary.main",
        textAlign: "center",
        padding: { xs: "8px 22px", sm: "10px 20px", md: "12px 16px" },
        paddingTop: { xs: "20px", sm: "35px", md: "28px" },
        borderRadius: "0 0 15px 15px",
        boxShadow: "4px 8px 15px rgba(0, 0, 0, 0.15)",
        zIndex: 1000,
        height: "fit-content",
        width: "fit-content",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#fff",
          fontWeight: "600",
          marginRight: "10px",
          display: { xs: "block", md: "block" },
        }}
      >
        Total Site Visits :
      </Typography>

      {/* Animated Counter */}
      <Typography
        variant="h6"
        sx={{
          color: "#ffeb3b",
          fontWeight: "600",
        }}
      >
        <animated.span>{number.to((n: number) => Math.floor(n))}</animated.span>
        +
      </Typography>
    </Box>
  );
};

export default SiteVisits;
